<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-8 offset-md-2">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">Servicios Unidades</h4>        
                    <hr>
                    <p> Administracion de los Servicios disponibles en las Unidades </p>                    
                </div>
            </div>            

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-high-traffic" data-toggle="tab" href="#service-high" role="tab" aria-controls="nav-home" aria-selected="true"><font-awesome-icon icon="plus" /> Nuevo Servicio</a>
                    <a class="nav-item nav-link" id="nav-edit-traffic" data-toggle="tab" href="#service-edit" role="tab" aria-controls="nav-profile" aria-selected="false"><font-awesome-icon icon="edit" /> Edición Servicio</a>
                    <a class="nav-item nav-link" id="nav-low-traffic" data-toggle="tab" href="#service-low" role="tab" aria-controls="nav-profile" aria-selected="false" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'"><font-awesome-icon icon="arrow-down" /> Baja Servicio</a>
                </div>
            </nav>

            <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="service-high" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6 align="center">Registro de Servicio</h6>
                    <hr>                    
                    
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-4" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'">
                            <label for="nombre_embarcacion">Unidad <span class="required-text">*</span></label>  
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div v-else class="alert alert-success col-12 col-md-4 offset-md-4" align="center">
                            {{ cDtsUser.name_port }}
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="nombre_embarcacion">Servicio <span class="required-text">*</span></label>  
                            <!-- listar las capitanias -->
                            <select name="service_uuss" class="form-control" id="service_uuss" v-model="service_new.service">
                                <option v-for="serv in services" :value="serv.id" :key="serv.id">{{ serv.detail }}</option>
                            </select>                         
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="nombre_embarcacion">Tipo Prestacion <span class="required-text">*</span></label>  
                            <!-- listar las capitanias -->
                            <select name="state_service" class="form-control" id="state_service" v-model="service_new.type">
                                <option v-for="tserv in types" :value="tserv.id" :key="tserv.id">{{ tserv.detail }}</option>
                            </select>                         
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="quality_service">Calidad Servicio<span class="required-text">*</span></label>
                            <select name="quality_service" class="form-control" id="quality_service" v-model="service_new.quality">
                                <option v-for="qa in qualitys" :value="qa.id" :key="qa.id">{{qa.detail}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="description_service">Descripcion del Servicio <span class="required-text">*</span></label>
                            <textarea type="text" class="form-control" name="description_service" v-model="service_new.description"> </textarea>
                        </div>
                    </div>
                    
                    <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mRegisterInitService">
                            <font-awesome-icon icon="save" size="3x" />
                    </button>

                </div>
                <!-- end first (high uuss) tab -->
                
                <div class="tab-pane fade"  id="service-edit" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6 align="center">Busqueda y Edicion de Servicios</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="service_edit.id > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ service_edit.captain }}</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseEdit">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Servicio</b></td>
                                    <td><b>Tipo</b></td>
                                    <td><b>Calidad</b></td>
                                </tr>
                                <tr>
                                    <td>
                                        <select name="services_edit" class="form-control" id="services_edit" disabled>
                                            <option v-for="eser in services" :value="eser.id" :key="eser.id" :selected="eser.id === service_edit.service ? true : false">{{eser.detail}}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select name="types_edit" class="form-control" id="types_edit" v-model="service_edit.type">
                                            <option v-for="typs in types" :value="typs.id" :key="typs.id" :selected="typs.id === service_edit.type ? true : false">{{typs.detail}}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select name="qualitys_edit" class="form-control" id="qualitys_edit" v-model="service_edit.quality">
                                            <option v-for="qua in qualitys" :value="qua.id" :key="qua.id" :selected="qua.id === service_edit.quality ? true : false">{{qua.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Descripcion del Servicio</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <textarea type="text" class="form-control" name="description_service_edit" v-model="service_edit.description"> </textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-info col-12 col-md-2 offset-md-4" @click="mUpdateService"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
                            </select>
                            <input type="text" class="form-control-plaintext" v-else :value="cDtsUser.name_port">
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchService(1)">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="list_service_edit.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Servicio / Tipo</th>
                                        <th>Calidad</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(serReg, index) in list_service_edit" :key="serReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ serReg.detail_service }}</span>
                                            / 
                                            <span>{{ serReg.detail_type }}</span>
                                        </td>
                                        <td>{{ serReg.detail_quality }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectServiceEdit(serReg)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
                    
                </div>
                <!-- end second (edit) tab -->

                <div class="tab-pane fade"  id="service-low" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>BAJA UUSS</h6>
                    <hr>
                    <transition name="fade" mode="out-in">

                    <div v-if="service_low.id > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ service_low.captain }}</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseLow">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Servicio</b></td>
                                    <td><b>Tipo</b></td>
                                    <td><b>Calidad</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" readonly class="form-control-plaintext" name="name_ship_edit" v-model="service_low.service"></td>
                                    <td>
                                        <input type="text" readonly class="form-control-plaintext" name="name_ship_edit" v-model="service_low.type">
                                    </td>
                                    <td>
                                        <input type="text" readonly class="form-control-plaintext" name="name_ship_edit" v-model="service_low.quality">
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Descripcion</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <textarea type="text" class="form-control-plaintext" readonly name="description_service" v-model="service_low.description" > </textarea>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Detalle Baja</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <textarea type="text" class="form-control" name="description_service_low" v-model="service_low.description_low"> </textarea> 
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-danger col-12 col-md-2 offset-md-4" @click="mLowService"><font-awesome-icon icon="arrow-circle-down" size="2x" /></button>
                        <button class="btn btn-warning col-12 col-md-2" @click="mCloseLow"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register" v-if="cDtsUser.roleAssign !== 'OPERADOR UNIDAD'">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
                            </select>
                            <input type="text" class="form-control-plaintext" v-else :value="cDtsUser.name_port">
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchService(2)">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="list_service_low.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Servicio / Tipo</th>
                                        <th>Calidad</th>
                                        <th><font-awesome-icon icon="times-circle" size="2x"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lser, index) in list_service_low" :key="lser.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ lser.detail_service }}</span>
                                            / 
                                            <span>{{ lser.detail_type }}</span>
                                        </td>
                                        <td>{{ lser.detail_quality }}</td>
                                        <td>
                                            <button class="btn btn-outline-danger" @click="mSelectShipLow(lser)">
                                                <font-awesome-icon icon="times-circle"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>   
                </div>
                <!-- end tirdth tab (low) -->

            </div>

        </div>
        <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'service',
    data(){
        return{
            list_service_edit:[],
            list_service_low:[],
            service_new:{
                id_captain:0,
                service:0,
                type:0,
                quality:0,
                description:null
            },
            service_edit:{
                id:0,
                captain:null,
                service:0,
                type:0,
                quality:0,
                description:null
            },
            service_low:{
                id:0,
                captain:null,
                service:null,
                type:null,
                quality:0,
                description:null
            },
            id_modal_progress:'load_service',
            title_modal:'Registrando',
            send_dispatch:true,
            ports:[],
            services:[],
            types:[],
            qualitys:[],
            captain_register:{
                id:0,
                name_port:null
            }
        }
    },
    mounted(){
        this.mInit();
    },
    methods:{
        mCloseEdit(){
            this.service_edit.id=0;
            this.service_edit.captain=0;
            this.service_edit.service=0;
            this.service_edit.type=0;
            this.service_edit.quality=0;
            this.service_edit.description=null;
        },
        mCloseLow(){
            this.service_low.id=0;
            this.service_low.captain=null;
            this.service_low.service=null;
            this.service_low.type=null;
            this.service_low.quality=null;
            this.service_low.description=null;
            this.service_low.description_low=null;
        },
        mSelectServiceEdit(sr){
            // console.log('la srve ha sido selecciosrda');
            // console.log(sr);
            this.service_edit.id=sr.id;
            this.service_edit.captain=sr.captain;
            this.service_edit.service=sr.service;
            this.service_edit.type=sr.type;
            this.service_edit.quality=sr.quality;
            this.service_edit.description=sr.description;
        },
        mSelectShipLow(srl){
            // console.log('la nave ha sido seleccionada');
            // console.log(na);
            this.service_low.id=srl.id;
            this.service_low.captain=srl.captain;
            this.service_low.service=srl.detail_service;
            this.service_low.type=srl.detail_type;
            this.service_low.quality=srl.detail_quality;
            this.service_low.description=srl.description;
            this.service_low.description_low=null;
        },
        async mSearchService(tv = 1){
            this.list_service_edit=[];
            this.list_service_low=[];

            if(this.cDtsUser.roleAssign !== 'OPERADOR UNIDAD'){
                if(this.captain_register.id===0){
                toastr.warning('Seleccione una UNIDAD', 'Unidad');
                return false;
            }
            }else{
                this.captain_register.id=this.cDtsUser.portId;
                this.captain_register.name_port=this.cDtsUser.name_port;
            }

            let list_service = await axios.get(`getServicesCaptain/${this.captain_register.id}?api_token=${Vue.auth.getToken()}`);
            // console.log(list_service);
            try {
                // console.log(tv);
                if(list_service.data.length > 0){
                    if(tv === 1){
                        this.list_service_edit=list_service.data;
                    }else{
                        this.list_service_low=list_service.data;
                    }
                }else{
                    toastr.info(`La unidad ${this.captain_register.name_port} no registra Servicios`, 'Mensaje');
                }                 
            } catch (error) {
                // console.log(error);
                toastr.error(`Ha ocurrido un error al Recuperar los datos`, 'Error SERV-02');
            }               
        },
        async mInit(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            let service=await axios.get(`globals/service?api_token=${Vue.auth.getToken()}`);
            let type=await axios.get(`globals/t_service?api_token=${Vue.auth.getToken()}`);
            let quality=await axios.get(`globals/qa_service?api_token=${Vue.auth.getToken()}`);
            this.ports=cp.data;
            this.services=service.data;
            this.types=type.data;
            this.qualitys=quality.data;
        },
        async mRegisterInitService(){
            // validamos y registramos la capitania
            if(this.mValidateRegister()){
                let message = {
                    title: 'Registro de Servicio',
                    body: `¿Desea Registrar el Servicio para la Unidad ${this.captain_register.name_port}?`
                }
                this.service_new.id_captain=this.captain_register.id;
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            // console.log(`estamos enviando al servidor`);
                            // console.log(this.service_new);
                            let reg_service=await axios.post(`serviceInsert?api_token=${Vue.auth.getToken()}`, qs.stringify(this.service_new));
                            // // console.log(reg_service);
                            setTimeout(()=>{                                
                                if(reg_service.data.status){
                                    toastr.success(reg_service.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.service_new.id_captain=0;
                                    this.service_new.service=0;
                                    this.service_new.type=0;
                                    this.service_new.quality=0;
                                    this.service_new.description=null;
                                    
                                }else{
                                    toastr.error(reg_service.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el registro', 'Error UUSS-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateRegister(){
            if(this.cDtsUser.roleAssign !== 'OPERADOR UNIDAD'){
                if(this.captain_register.id===0){
                toastr.warning('Seleccione una Unidad', 'Unidad');
                return false;
            }
            }else{
                this.captain_register.id=this.cDtsUser.portId;
                this.captain_register.name_port=this.cDtsUser.name_port;
            }
            // if(this.uuss_new.name===null || this.uuss_new.name===''){
            //     toastr.warning('Indique el nombre de la nave', 'Atencion');
            //     return false;
            // }
            if(this.service_new.service===0){
                toastr.warning('Indique El servicio', 'Servicio');
                return false;
            }
            if(this.service_new.type===0){
                toastr.warning('Indique el tipo de Servicio', 'Tipo Servicio');
                return false;
            }

            if(this.service_new.quality===0){
                toastr.warning('Seleccione la calidad del servicio', 'Calidad Servicio');
                return false;
            }
            return true;
        },
        async mUpdateService(){
            // validamos y registramos la capitania
            if(this.mValidateUpdate()){
                let message = {
                    title: 'Actualizacion Servicio',
                    body: `¿Desea Actualizar el Servicio para la Unidad ${this.service_edit.captain}?`
                }
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            
                            let update_service=await axios.post(`serviceUpdate?api_token=${Vue.auth.getToken()}`, qs.stringify(this.service_edit));
                            
                            this.mSearchService(1);

                            setTimeout(()=>{                                
                                if(update_service.data.status){
                                    toastr.success(update_service.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.mCloseEdit();
                                }else{
                                    toastr.success(update_service.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en la actualizacion', 'Error Service-02')
                                
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateUpdate(){
            // if(this.engine_edit.trademark===0){
            //     toastr.warning('Seleccione un tipo de nave', 'Tipo Nave');
            //     return false;
            // }
            if(this.service_edit.type===0){
                toastr.warning('Debe seleccionar un Tipo de Servicio', 'Tipo Servicio');
                return false;
            }
            if(this.service_edit.quality===0){
                toastr.warning('Seleccione la calidad del Servicio', 'Calidad Servicio');
                return false;
            }
            
            return true;
        },
        async mLowService(){
            // validamos y registramos la capitania
            if(this.mValidateLow()){
                let message = {
                    title: 'Baja Servicio',
                    body: `¿Desea dar de Baja el Servicio para la Unidad ${this.service_low.captain}?`
                }
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            
                            let low_service=await axios.post(`lowService?api_token=${Vue.auth.getToken()}`, qs.stringify(this.service_low));
                            
                            this.mSearchService(2);
                            this.mSearchService(1);

                            setTimeout(()=>{                                
                                if(low_service.data.status){
                                    toastr.success(low_service.data.response, 'Exito');
                                    this.mCloseLow();
                                }else{
                                    toastr.success(low_service.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en la baja del servicio', 'Error Service-02')
                                
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateLow(){
            if(this.service_low.description_low===null || this.service_low.description_low === '' ){
                toastr.warning('Indique una breve descripcion de las causales de la baja', 'Atencion');
                return false;
            }
            return true;
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-loading':modalLoading
    }    
}
</script>

<style>
.required-text{
    color:red; 
    font-weight:bold;
}
</style>


// WEBPACK FOOTER //
// src/components/services/services.vue